import { IotSkeleton } from "@core/presentation/components/feedback/skeleton/iot-skeleton.component";
import type { FC, SuspenseProps } from "react";
import { Suspense } from "react";

export interface IotSuspenseProps extends SuspenseProps {
    id?: string;
}

export const IotSuspense: FC<IotSuspenseProps> = (props) => (
    <Suspense
        {...props}
        fallback={props.fallback ?? <IotSkeleton loading />}
    />
);
